export class EmailTable {

  public static ON_REG = "onReg";
  public static ON_PAY = "onPay";
  public static ON_CASH = "onCash";

  public static key_name = '{field:jmeno}';
  public static key_surname = '{field:prijmeni}';
  public static key_year = '{field:roknarozeni}';
  public static key_club = '{field:klub}';
  public static key_startFee = '{field:startovne}';
  public static key_varSym = '{field:varSym}';
  public static key_account = '{field:ucet}';
  public static key_note = '{field:poznamka}';
  public static key_mobile = '{field:telefon}';
  public static key_email = '{field:email}';
  public static key_city = '{field:mesto}';
  public static key_custNote = '{field:pozn}';

  id;
  onRegFrom;
  onRegSubject;
  onRegMessage;
  onPayFrom;
  onPaySubject;
  onPayMessage;
  messageType;
  onCashFrom;
  onCashSubject;
  onCashMessage;

}
